import { DataModel } from "common/models/utility-models/base-model";

export class HelpModel extends DataModel {
    content : string = ""
}